import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens/src';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { HttpLoaderFactory } from './httpLoaderFactory';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient, ENV_CONFIG],
      },
      isolate: false,
    }),
  ],
  exports: [TranslateModule],
})
export class I18nModule {}
